<template>
  <div class="HintsTemplate animated fadeIn">
    <label class="HintsTemplate__important">Wybrana opcja:</label>
    Zadzwoń w zamówionym przez użytkownika terminie.
    <ol class="HintsTemplate__description HintsTemplate__list">
      <li>System call web pobierze numer telefonu od użytkownika.</li>
      <li>
        Użytkownik będzie miał możliwość wyboru wygodnego dla niego terminu i godziny kontaktu.
        Wybór dni oraz godzin uzależniony jest od ustawień <b>“Harmonogramu dostępności”</b>.
      </li>
      <li>System wykona połączenie do użytkownika w wybranym przez niego terminie.</li>
      <li>
        Użytkownik usłyszy krótką zapowiedź głosową, po czym system call web zadzwoni
        do konsultantów zgodnie z ustawieniami widgetu w godzinach ich dostępności.
      </li>
      <li>Zamówione i oczekujące połączenie będzie widoczne w zakładce <b>Połączenia</b> ze statusem: ZAMÓWIONE POŁĄCZENIE.</li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'CallbackAutoAfterhoursBehavior',
};
</script>
